import {Dict} from './common.interfaces';
import {SafeHtml} from '@angular/platform-browser';

export interface AvatarConfig {
  type?: string;
  src?: string;
}

export class User {
  id?: number;
  username?: string;
  email?: string;
  isFirstLogIn?: boolean;
  isSuperUser?: boolean;
  organizations?: Organization[];
  leveling?: {
    level?: number;
    xp?: number;
    xpToNextLevel?: number;
  };
  subscriptionPlan?: SubscriptionPlan;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  avatarConfig?: AvatarConfig;
  privacySettings?: Record<string, any>;
}

export interface SubscriptionPlan {
  planName: string;
  startDate: Date;
  endDate: Date;
}


export class ODM {
  id?: number;
  sender: string | 'anonymous';
  type: 'bad_location_report' | 'quest_publication_approved' | 'quest_publication_rejected';
  message?: string;
  suppliedData: Dict<any>;
  createdAt: Date;
  isRead: boolean;
}

export class Organization {
  id?: number;
  type?: string;
  name?: string;
  description?: string;
  primaryColor?: string;
  secondaryColor?: string;
  logo?: SafeHtml;
  secondaryLogo?: string;
  role?: string;
  // members?: OrganizationMember[];
}
